//@flow
import React from 'react';
import { Link } from 'react-router';
import CategoriesListItem from './CategoriesListItem.react';
import {getIsCategoryHighlighted} from '../../Stores/MemberCategories/categoriesCollection';

import type CategoryModel from '../../Stores/MemberCategories/categoryModel';

type Props = {
  items:CategoryModel[],
};

function _renderItem(item:CategoryModel) {
  return (
    <CategoriesListItem
      key={item.getId()}
      item={item}
      highlighted={getIsCategoryHighlighted(item.getUrlKey())}
    />
  );
}

export default function CategoriesDropdown(props:Props) {
  return (
    <div tabIndex="0" role="tabpanel" className="nb-dropdown">
      <div className="nb-dropdown-label-container">
        <Link to="/products" className="nb-dropdown-label-link">
          <div className="nb-dropdown-label">
            Shop by Categories
          </div>
          <div className="nb-dropdown-icon">
          </div>
        </Link>
      </div>
      <ul aria-hidden="false" aria-label="submenu" className="nb-dropdown-items">
        {props.items.map(_renderItem)}
      </ul>
    </div>
  );
}
